import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { SocialIcon } from '@dynamic-labs/iconic';
import { Typography } from '../../../Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import { logger } from '../../../../shared/logger.js';
import '@dynamic-labs/multi-wallet';
import '../../../../context/ViewContext/ViewContext.js';
import { ReactComponent as SvgAdd } from '../../../../shared/assets/add.js';
import { ReactComponent as SvgUnlink } from '../../../../shared/assets/unlink.js';
import '../../../../utils/constants/colors.js';
import '../../../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import '../../../ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import { Icon } from '../../../Icon/Icon.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../Transition/ZoomTransition/ZoomTransition.js';
import '../../../Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../Transition/OpacityTransition/OpacityTransition.js';
import { unlinkOAuth, verifyOAuth } from '../../../../data/api.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { Button } from '../../../Button/Button.js';
import '../../../IconButton/IconButton.js';
import { capitalize } from '../../../../widgets/DynamicWidget/helpers/helpers.js';
import { useUpdateUserProfileByJWTCallback } from '../../../../utils/hooks/useUpdateUserProfileByJWTCallback/useUpdateUserProfileByJWTCallback.js';
import { ConnectedAccountAvatar } from './components/ConnectedAccountAvatar/ConnectedAccountAvatar.js';

const UserProfileSocialAccount = ({ provider, authorizationUrl, verifiedCredential, }) => {
    var _a, _b;
    const { environmentId, onboardingOnlyJwt, authToken } = useInternalDynamicContext();
    const { updateUserProfileByJWT } = useUpdateUserProfileByJWTCallback();
    const [loading, setLoading] = useState(false);
    const connectAccount = () => {
        setLoading(true);
        const authWindow = window.open(authorizationUrl, '_blank', 'width=500,height=600');
        const handleAuthWindowMessage = (event) => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) !== 'authorization_response' ||
                ((_b = event.data) === null || _b === void 0 ? void 0 : _b.provider) !== provider) {
                return;
            }
            const { code } = event.data;
            const jwt = yield verifyOAuth(environmentId, provider, {
                code,
            }, String(authToken || onboardingOnlyJwt));
            if (!jwt) {
                return;
            }
            yield updateUserProfileByJWT(jwt);
            setLoading(false);
        });
        window.addEventListener('message', handleAuthWindowMessage);
        const authWindowInterval = setInterval(() => {
            if (authWindow === null || authWindow === void 0 ? void 0 : authWindow.closed) {
                window.removeEventListener('message', handleAuthWindowMessage);
                clearInterval(authWindowInterval);
                setLoading(false);
            }
        }, 1000);
    };
    const disconnectAccount = () => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        try {
            setLoading(true);
            const jwt = yield unlinkOAuth({
                environmentId,
                verifiedCrentialId: (_c = verifiedCredential === null || verifiedCredential === void 0 ? void 0 : verifiedCredential.id) !== null && _c !== void 0 ? _c : '',
            }, String(authToken || onboardingOnlyJwt));
            if (!jwt) {
                return;
            }
            updateUserProfileByJWT(jwt);
        }
        catch (err) {
            logger.error(err);
        }
        finally {
            setLoading(false);
        }
    });
    if (!verifiedCredential && !authorizationUrl) {
        return null;
    }
    return (jsxs("div", Object.assign({ className: 'user-profile-social-account', "data-testid": `social-account-${provider}` }, { children: [jsx("div", Object.assign({ className: 'user-profile-social-account__icon' }, { children: verifiedCredential ? (jsx(ConnectedAccountAvatar, { provider: provider, avatarUrl: (_a = verifiedCredential.oauthAccountPhotos) === null || _a === void 0 ? void 0 : _a[0] })) : (jsx(SocialIcon, { name: provider })) })), jsx("div", Object.assign({ className: 'user-profile-social-account__label' }, { children: jsx(Typography, Object.assign({ weight: 'medium', variant: 'body_normal', color: 'primary' }, { children: (_b = verifiedCredential === null || verifiedCredential === void 0 ? void 0 : verifiedCredential.publicIdentifier) !== null && _b !== void 0 ? _b : capitalize(provider) })) })), verifiedCredential ? (jsx(Button, { buttonClassName: 'user-profile-social-account__button', buttonVariant: 'secondary', buttonRounded: 'small', buttonPadding: 'none', onClick: disconnectAccount, loading: loading, dataTestId: 'social-account-disconnect-button', typographyProps: {
                    color: 'secondary',
                    variant: 'button_tertiary',
                }, startSlot: 
                // eslint-disable-next-line react/jsx-wrap-multilines
                jsx(Icon, Object.assign({ color: 'text-tertiary', size: 'small' }, { children: jsx(SvgUnlink, {}) })) })) : (jsx(Button, Object.assign({ buttonClassName: 'user-profile-social-account__button', buttonVariant: 'secondary', buttonRounded: 'small', buttonPadding: 'none', onClick: connectAccount, loading: loading, dataTestId: 'social-account-connect-button', typographyProps: {
                    color: 'secondary',
                    variant: 'button_tertiary',
                    weight: 'medium',
                }, startSlot: 
                // eslint-disable-next-line react/jsx-wrap-multilines
                jsx(Icon, Object.assign({ color: 'text-tertiary', size: 'xsmall' }, { children: jsx(SvgAdd, {}) })) }, { children: "Connect" })))] })));
};

export { UserProfileSocialAccount };
